module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"header":"Filialen","departments":"Unsere Filialen","department":"Niederlassung","departmentSite":"zur Filialseite"},"en":{"header":"Branches","departments":"Our branches","department":"Branch","departmentSite":"Branch page"}}')
  delete Component.options._Ctor
}
